// import Highcharts from "highcharts/highstock";
import CAMCFundIndustryDistribution from "./camc-fund-industry-distribution";

class WebsiteFundIndustryDistribution extends CAMCFundIndustryDistribution {
    constructor(fundCode) {
        super(fundCode, reportTime);
        this.$root = $(".tabs-content-amc.industry-distribution");
    }

    setEmptyMessage(target = "#industry-distribution-container", emptyMessage = "暂无数据显示") {
        let $targetObj = this.$root.find(target);
        if ($targetObj) {
            $targetObj.empty();
            $targetObj.append(`<div class="api-messaging-content grid-x align-center-middle">${emptyMessage}</div>`);
        }
    }

    errorHandler() {
        showApiMessageing(null);
        this.setEmptyMessage("#industry-distribution-container");
    }

    updateFundDate(date) {
        this.$root.find(".container-updatetime-portfolio").text("数据截止日期：" + date);
    }

    generateIndustryDistributionTable(sector_a, sector_h) {
        var $legendA = this.$root.find("#industry-distribution-container-table__a").empty();
        var $legendH = this.$root.find("#industry-distribution-container-table__h").empty();
        if (sector_a.length || sector_h.length) {
            if (sector_a.length > 0) {
                let headerItem = `
                    <div class="item-title">
                        <div class="series series__name">行业类别 - A股</div>
                        <div class="series series__percent">占基金资产净值比例</div>
                    </div>
                `;
                $legendA.append(headerItem);
                const $equityDataArray = sector_a;
                $equityDataArray.forEach(function (element, index) {
                    let contentItem = `
                        <div class="item">
                            <div class="series series__name">${element.name}</div>
                            <div class="series series__percent">${Highcharts.numberFormat(element.y).replace(
                                ",",
                                " ",
                            )}%</div>
                        </div>
                    `;
                    $legendA.append(contentItem);
                });
            } else {
                $legendA.remove();
                this.setEmptyMessage(
                    ".empty-message",
                    "<span>本基金本报告期末</span><span>未持有境内股票投资组合</span>",
                );
            }

            if (sector_h.length > 0) {
                let headerItem = `
                <div class="item-title">
                    <div class="series series__name">行业类别 - H股</div>
                    <div class="series series__percent">占基金资产净值比例</div>
                </div>
            `;
                $legendH.append(headerItem);
                const $equityDataArray = sector_h;
                $equityDataArray.forEach(function (element, index) {
                    let contentItem = `
                    <div class="item">
                        <div class="series series__name">${element.name}</div>
                        <div class="series series__percent">${Highcharts.numberFormat(element.y).replace(
                            ",",
                            " ",
                        )}%</div>
                    </div>
                    `;
                    $legendH.append(contentItem);
                });
            } else {
                $legendH.remove();
                this.setEmptyMessage(
                    ".empty-message",
                    "<span>本基金本报告期末</span><span>未持有境外股票投资组合</span>",
                );
            }
        } else {
            $legendA.remove();
            $legendH.remove();
            if (this.reportTime) {
                this.setEmptyMessage(".empty-message", "<span>本基金本报告期末</span><span>未持有股票投资组合</span>");
            } else {
                this.setEmptyMessage(".empty-message");
            }
        }
    }
}

$(function () {
    if (window.fundCode && $(".fund-portfolio-div .industry-distribution").length) {
        const camcFundIndustryDistribution = new WebsiteFundIndustryDistribution(window.fundCode);
        camcFundIndustryDistribution.render();
    }
});
